<template>
<div id="tree-layout">

  <!-- <div id="tree-info">
    page_xy: {{mouse_pageXY.x}}, {{mouse_pageXY.y}} | 
    cvs_grid W, H : {{parseInt(cvs_grid.width)}}, {{parseInt(cvs_grid.height)}}  |
    cvs_size W, H : {{parseInt(cvs_size.width)}}, {{parseInt(cvs_size.height)}}  |
    W (screen, window, page) : {{screen.width}}, {{window.width}}, {{page.width}}

  </div> -->
  <div v-if="busy" id="tree-loading">
    <v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
  </div>

  <div v-else>
    <svg id="tree" ref="tree" :width="page.width"  :height="page.height">
      <!-- cvs area - zoom & panning -->
      <g v-if="treeReady"
        @pointermove="detect_mouse_move()"        
        @pointerdown="detect_mouse_down()"
        @pointerup="detect_mouse_up()"
        @click="checkClick()"
      >
        <!-- cvs -->
        <g>
          <!-- window inner area -->
          <rect :x=0 :y=0 :width="page.width" :height="page.height" 
            fill="rgb(255, 255, 255)"></rect>
          
          <!-- canvas -->
          <rect :x="cvs_position.x_left" :y="cvs_position.y_top"
            :width="cvs_size.width" :height="cvs_size.height" 
            :stroke="coloring('bw', 1, 1)" 
            stroke-width="0"
            fill="rgb(255, 255, 255)"></rect>
        </g>
        <!-- edge -->
        <g v-for="e in eTable" :key="e.ei">
          <line 
            :x1="cv2pgX(e.sx)" :x2="cv2pgX(e.tx)" 
            :y1="cv2pgY(e.sy)" :y2="cv2pgY(e.ty)"
            :stroke="edgeColor('B', e)" 
            :stroke-dasharray="edgeDash('B', e)"
            :stroke-width="edgeWidth('B', e)"
          ></line>
        </g>
        
        <!-- vertex -->
        <g v-for="v in vTable" :key="v.vid+0.1">
          <!-- project or document -->
          <g v-if="v.vid==0">
            <circle
              :cx="cv2pgX(v.x)"
              :cy="cv2pgY(v.y)"
              :r="20"
              :fill="coloring('lotus', 1, 0.2)"
              @pointerover="onV=true; onVertex=v"
              @click="checkClick()"
            ></circle>
            <text
              :x="cv2pgX(v.x)"
              :y="cv2pgY(v.y)+20"
              dominant-baseline="hanging"
              text-anchor="middle"
              class="base_vertex"
              @click="checkClick()"
            > {{base_node.tree_mode}} | {{project_info.title}}
            </text>
          </g>

          <!-- clicked Halo -->
          <g>
            <!-- clicked main --> 
            <circle v-if="v.vid==clickVertex.vid"
              :cx="cv2pgX(v.x)"
              :cy="cv2pgY(v.y)"
              :r="vertexSize('CH', 2, 1, v)"
              :fill="vertexColor('CH', 2, 1, v)"
              @pointerover="onV=true;onVertex=v"
              @click="checkClick()"
            ></circle>
            <!-- clicked Up -->
            <circle v-if="OutCV.includes(v.vid)"
              :cx="cv2pgX(v.x)"
              :cy="cv2pgY(v.y)"
              :r="vertexSize('CU', 2, 1, v)"
              :fill="vertexColor('CU', 2, 1, v)"
              @pointerover="onV=true;onVertex=v"
              @click="checkClick()"
            ></circle>
            <!-- clicked Down -->
            <circle v-if="InCV.includes(v.vid)"
              :cx="cv2pgX(v.x)"
              :cy="cv2pgY(v.y)"
              :r="vertexSize('CD', 2, 1, v)"
              :fill="vertexColor('CD', 2, 1, v)"
              @pointerover="onV=true;onVertex=v"
              @click="checkClick()"
            ></circle>
          </g>
          <!-- n_nodes>1 : vertex -->
          <!-- vertexColor(type, multiple(1 or 2), halo(0 or 1), vertex) -->
          <g v-if="v.n_nodes>1">        
            <circle v-if="v.vid==clickVertex.vid"
              :cx="cv2pgX(v.x)"
              :cy="cv2pgY(v.y)"
              :r="vertexSize('CB', 2, 0, v)"
              :stroke="vertexOutlineColor('CB', 2, 0, v)"
              :stroke-width="vertexOutline('CB', 2, 0, v)"
              :fill="vertexColor('CB', 2, 0, v)" 
              @pointerover="onV=true;onVertex=v"
              @click="checkClick()"
            ></circle>
            <circle v-else
              :cx="cv2pgX(v.x)"
              :cy="cv2pgY(v.y)"
              :r="vertexSize('B', 2, 0, v)"
              :stroke="vertexOutlineColor('B', 2, 0, v)"
              :stroke-width="vertexOutline('B', 2, 0, v)"
              :fill="vertexColor('B', 2, 0, v)" 
              @pointerover="onV=true;onVertex=v"
              @click="checkClick()"
            ></circle>
          </g>
          <g v-else>
            <circle v-if="v.vid==clickVertex.vid"
              :cx="cv2pgX(v.x)"
              :cy="cv2pgY(v.y)"
              :r="vertexSize('CB', 1, 0, v)"
              :stroke="vertexOutlineColor('CB', 1, 0, v)"
              :stroke-width="vertexOutline('CB', 1, 0, v)"
              :fill="vertexColor('CB', 1, 0, v)"
              @pointerover="onV=true;onVertex=v"
              @click="checkClick()"
            ></circle>
            <circle v-else
              :cx="cv2pgX(v.x)"
              :cy="cv2pgY(v.y)"
              :r="vertexSize('B', 1, 0, v)"
              :stroke="vertexOutlineColor('B', 1, 0, v)"
              :fill="vertexColor('B', 1, 0, v)"
              @pointerover="onV=true;onVertex=v"
              @click="checkClick()"
            ></circle>
          </g>
          
        </g>
        <!-- vertex text -->
        <g v-for="v in vTable" :key="v.vid">
          <g v-if="v.n_nodes>1">        
            <text
              :x="cv2pgX(v.x)"
              :y="cv2pgY(v.y)"
              dominant-baseline="middle"
              text-anchor="middle"
              :fill="textColor('N', 'bw', 1)"
              class="num-in-v"
              @pointerover="onV=true;onVertex=v"
              @click="checkClick()"
            >{{v.n_nodes}} 
            </text>
          </g>
        </g>
        <!-- project documents network -->
        <g v-if="onPD">
          <!-- edge -->
          <g v-for="e in eProjectDocs" :key="e.ei">
            <line 
              :x1="cv2pgX(e.sx)" 
              :x2="cv2pgX(e.tx)" 
              :y1="cv2pgY(e.sy)" 
              :y2="cv2pgY(e.ty)"
              :stroke="edgeColor('P', e)"
              :stroke-dasharray="edgeDash('P', e)"
              :stroke-width="edgeWidth('P', e)"
            ></line>
          </g>
          <!-- vertex -->
          <g v-for="v in vProjectDocs" :key="v.vid">
            <!-- n_nodes>1 : vertex -->
            <g v-if="v.n_nodes>1">        
              <circle
                :cx="cv2pgX(v.x)"
                :cy="cv2pgY(v.y)"
                :r="vertexSize('P', 2, 0, v)"
                :stroke="vertexOutlineColor('P', 2, 0, v)"
                :stroke-width="line_width.w15"
                :fill="vertexColor('P', 2, 0, v)"
                @pointerover="onV=true;onVertex=v"
                @click="checkClick()"
                ></circle>
            </g>
            <g v-else>
              <circle
                :cx="cv2pgX(v.x)"
                :cy="cv2pgY(v.y)"
                :r="vertexSize('P', 1, 0, v)"
                :stroke="vertexOutlineColor('P', 1, 0, v)"
                :fill="vertexColor('P', 1, 0, v)"
                :stroke-width="line_width.w15"
                @pointerover="onV=true;onVertex=v"
                @click="checkClick()"
              ></circle>
            </g>
          </g>
        </g>
        <!-- project documents network text -->
        <g v-if="onPD">
          <g v-for="v in vProjectDocs" :key="v.vid">
            <!-- n_nodes>1 : vertex -->
            <g v-if="v.n_nodes>1">        
              <text
                :x="cv2pgX(v.x)"
                :y="cv2pgY(v.y)"
                dominant-baseline="middle"
                text-anchor="middle"
                :fill="textColor('N', 'navy', 1)"
                class="num-in-v"
                @pointerover="onV=true;onVertex=v"
                @click="checkClick()"
              >{{v.n_nodes}} 
              </text>
            </g>
            <g v-else>
              <text v-if="v.vid!=0"
                :x="cv2pgX(v.x)+2*v.w"
                :y="cv2pgY(v.y)-2"
                dominant-baseline="top-center"
                text-anchor="start"
                class="graph-filter-text-au"
                @click="checkClick()"
              >
                {{v.nodes_obj[0].info_au}} ({{v.nodes_obj[0].year}})
              </text>
              <text v-if="v.vid!=0"
                :x="cv2pgX(v.x)+2*v.w"
                :y="cv2pgY(v.y)"
                dominant-baseline="hanging"
                text-anchor="start"
                class="graph-filter-text-title"
                @click="checkClick()"
              >
                {{v.nodes_obj[0].info_title}}
              </text>
            </g>
          </g>
        </g>

        <!-- suggestion flow -->
        <g v-if="onSG">
          <!-- edge -->
          <g v-for="e in eSuggestion" :key="e.ei">
            <line 
              :x1="cv2pgX(e.sx)" 
              :x2="cv2pgX(e.tx)" 
              :y1="cv2pgY(e.sy)" 
              :y2="cv2pgY(e.ty)"
              :stroke="edgeColor('S', e)"
              :stroke-dasharray="edgeDash('S', e)"
              :stroke-width="edgeWidth('S', e)"
              marker-end="url(#arrow)"
            ></line>
          </g>      
          <!-- vertex -->
          <g v-for="v in vSuggestion" :key="v.vid">
            <!-- n_nodes>1 : vertex -->
            <g v-if="v.n_nodes>1">        
              <circle
                :cx="cv2pgX(v.x)"
                :cy="cv2pgY(v.y)"
                :r="vertexSize('S', 2, 0, v)"
                :stroke="vertexOutlineColor('S', 2, 0, v)"
                :stroke-width="line_width.w9"
                :fill="vertexColor('S', 2, 0, v)"
                @pointerover="onV=true;onVertex=v"
                @click="checkClick()"
                ></circle>
            </g>
            <g v-else>
              <circle
                :cx="cv2pgX(v.x)"
                :cy="cv2pgY(v.y)"
                :r="vertexSize('S', 1, 0, v)"
                :fill="vertexColor('S', 1, 0, v)"
                :stroke="vertexOutlineColor('S', 1, 0, v)"
                :stroke-width="line_width.w9"
                @pointerover="onV=true;onVertex=v"
                @click="checkClick()"
              ></circle>
            </g>
          </g>
        </g>
        <!-- suggestion flow text -->
        <g v-if="onSG">
          <g v-for="v in vSuggestion" :key="v.vid">
            <!-- n_nodes>1 : vertex -->
            <g v-if="v.n_nodes>1">        
            </g>
            <g v-else>
              <text v-if="v.vid!=0"
                :x="cv2pgX(v.x)+2*v.w"
                :y="cv2pgY(v.y)-2"
                dominant-baseline="top-center"
                text-anchor="start"
                class="graph-filter-text-au"
                @click="checkClick()"
              >
                {{v.nodes_obj[0].info_au}} ({{v.nodes_obj[0].year}})
              </text>
              <text v-if="v.vid!=0"
                :x="cv2pgX(v.x)+2*v.w"
                :y="cv2pgY(v.y)"
                dominant-baseline="hanging"
                text-anchor="start"
                class="graph-filter-text-title"
                @click="checkClick()"
              >
                {{v.nodes_obj[0].info_title}}
              </text>
            </g>
          </g>
        </g>
        
        <!-- hover -->
        <g v-if="onV">
          <!-- edge-->
          <g v-for="e in LinkOnVertexUp" :key="e.ei">
            <line
              :x1="cv2pgX(e.sx)" 
              :x2="cv2pgX(e.tx)" 
              :y1="cv2pgY(e.sy)" 
              :y2="cv2pgY(e.ty)"
              :stroke="edgeColor('U', e)"
              :stroke-dasharray="edgeDash('U', e)"
              :stroke-width="edgeWidth('U', e)"
            ></line>
          </g>
          <g v-for="e in LinkOnVertexDown" :key="e.ei">
            <line
              :x1="cv2pgX(e.sx)" 
              :x2="cv2pgX(e.tx)" 
              :y1="cv2pgY(e.sy)" 
              :y2="cv2pgY(e.ty)"
              :stroke="edgeColor('D', e)"
              :stroke-dasharray="edgeDash('D', e)"
              :stroke-width="edgeWidth('D', e)"
            ></line>
          </g>
          <!-- vertex outs-->
          <g v-for="v in OutOnVertex" :key="v.vid">
            <!-- n_nodes>1 : vertex -->
            <g v-if="v.n_nodes>1">       
              <circle
                :cx="cv2pgX(v.x)"
                :cy="cv2pgY(v.y)"
                :r="vertexSize('U', 2, 0, v)"
                :stroke="vertexOutlineColor('U', 2, 0, v)"
                :stroke-width="line_width.w0"
                :fill="vertexColor('U', 2, 0, v)"
                @pointerover="onV=true;onVertex=v"
                @click="checkClick()"

              ></circle>
              <text
                :x="cv2pgX(v.x)"
                :y="cv2pgY(v.y)"
                dominant-baseline="middle"
                text-anchor="middle"
                class="num-in-v"
                @pointerover="onV=true;onVertex=v"
                @click="checkClick()"
              >{{v.n_nodes}} 
              </text>
            </g>
            <g v-else>
              <circle
                :cx="cv2pgX(v.x)"
                :cy="cv2pgY(v.y)"
                :r="vertexSize('U', 1, 0, v)"
                :stroke="vertexOutlineColor('U', 1, 0, v)"
                :fill="vertexColor('U', 1, 0, v)"
                @pointerover="onV=true;onVertex=v"
                @click="checkClick()"
              ></circle>
            </g>
          </g>
          <!-- vertex ins-->
          <g v-for="v in InOnVertex" :key="v.vid">
            <!-- n_nodes>1 : vertex -->
            <g v-if="v.n_nodes>1">            
              <circle
                :cx="cv2pgX(v.x)"
                :cy="cv2pgY(v.y)"
                :r="vertexSize('D', 2, 0, v)"
                :stroke="vertexOutlineColor('D', 2, 0, v)"
                :stroke-width="line_width.w0"
                :fill="vertexColor('D', 2, 0, v)"
                @pointerover="onV=true;onVertex=v"
                @click="checkClick()"
                ></circle>
                <text
                :x="cv2pgX(v.x)"
                :y="cv2pgY(v.y)"
                dominant-baseline="middle"
                text-anchor="middle"
                class="num-in-v"
                @pointerover="onV=true;onVertex=v"
                @click="checkClick()"
              >{{v.n_nodes}} 
              </text>
            </g>
            <g v-else>
              <circle
                :cx="cv2pgX(v.x)"
                :cy="cv2pgY(v.y)"
                :r="vertexSize('D', 1, 0, v)"
                :stroke="vertexOutlineColor('D', 1, 0, v)"
                :fill="vertexColor('D', 1, 0, v)"
                @pointerover="onV=true;onVertex=v"
                @click="checkClick()"
              ></circle>
            </g>
          </g>
          <!-- vertex on-->
          <g>
            <!-- n_nodes>1 : vertex -->
            <g v-if="onVertex.n_nodes>1">
              <!-- halo -->
              <circle
                :cx="cv2pgX(onVertex.x)"
                :cy="cv2pgY(onVertex.y)"
                :r="vertexSize('H', 2, 1, onVertex)"
                :stroke="vertexOutlineColor('H', 2, 1, onVertex)"
                :stroke-width="line_width.w0"
                :fill="vertexColor('H', 2, 1, onVertex)"
                @pointerleave="onV=false;onVertex=null"
                @click="clickVertexM(onVertex)"
                ></circle>
              <!-- main -->
              <circle
                :cx="cv2pgX(onVertex.x)"
                :cy="cv2pgY(onVertex.y)"
                :r="vertexSize('H', 2, 0, onVertex)"
                :stroke="vertexOutlineColor('H', 2, 0, onVertex)"
                :stroke-width="line_width.w0"
                :fill="vertexColor('H', 2, 0, onVertex)"
                @click="clickVertexM(onVertex)"
                ></circle>
                <text
                :x="cv2pgX(onVertex.x)"
                :y="cv2pgY(onVertex.y)"
                dominant-baseline="middle"
                text-anchor="middle"
                class="num-in-v-white"
                @click="clickVertexM(onVertex)"
              > {{onVertex.n_nodes}}
              </text>
            </g>
            <g v-else>
              <!-- halo -->
              <circle
                :cx="cv2pgX(onVertex.x)"
                :cy="cv2pgY(onVertex.y)"
                :r="vertexSize('H', 1, 1, onVertex)"
                :stroke="vertexOutlineColor('H', 1, 1, onVertex)"
                :fill="vertexColor('H', 1, 1, onVertex)"
                @pointerleave="onV=false;onVertex=null"
                @click="clickVertexS(onVertex)"
              ></circle>
              <!-- main -->
              <circle
                :cx="cv2pgX(onVertex.x)"
                :cy="cv2pgY(onVertex.y)"
                :r="vertexSize('H', 1, 0, onVertex)"
                :stroke="vertexOutlineColor('H', 1, 0, onVertex)"
                :fill="vertexColor('H', 1, 0, onVertex)"
                @click="clickVertexS(onVertex)"
              ></circle>
              <text v-if="onVertex.vid!=0"
                :x="cv2pgX(onVertex.x)+2*onVertex.w"
                :y="cv2pgY(onVertex.y)-2"
                dominant-baseline="top-center"
                text-anchor="start"
                class="hover-info-au"
              >
                {{onVertex.nodes_obj[0].info_au}} ({{onVertex.nodes_obj[0].year}})
              </text>
              <text v-if="onVertex.vid!=0"
                :x="cv2pgX(onVertex.x)+2*onVertex.w"
                :y="cv2pgY(onVertex.y)"
                dominant-baseline="hanging"
                text-anchor="start"
                class="hover-info-title"
              >
                {{onVertex.nodes_obj[0].info_title}}
              </text>
            </g>
          </g>
        </g>
        <!-- zoom bar, etc. -->
        <g>
          <!-- on project documents -->
          <text
            x=55
            y=50
            dominant-baseline="middle"
            text-anchor="start"
            :fill="onPD_sign_color"
            class="graph-filter"
          >프로젝트 도큐먼트</text>
          <circle v-if="vProjectDocs.length>0"
            cx=40
            cy=50
            r=7
            @click="onProjectDocs()"
            :stroke="coloring('navy', 0.2, 1)"
            :stroke-width="line_width.w5"
            :fill="onPD_select_color"
          ></circle>
          <circle v-else
            cx=40
            cy=50
            r=7
            :stroke="coloring('navy', 0.2, 0.5)"
            :stroke-width="line_width.w5"
            :fill="onPD_select_color"
          ></circle>
          <!-- on suggestion -->
          <text
            x=55
            y=80
            dominant-baseline="middle"
            text-anchor="start"
            :fill="onSG_sign_color"
            class="graph-filter"
          >추천 도큐먼트</text>
          <circle v-if="vSuggestion.length>0"
            cx=40
            cy=80
            r=7
            @click="onSuggestion()"
            :stroke="coloring('lime', 0.2, 1)"
            :stroke-width="line_width.w5"
            :fill="onSG_select_color"
          ></circle>
          <circle v-else
            cx=40
            cy=80
            r=7
            :stroke="coloring('lime', 0.2, 0.5)"
            :stroke-width="line_width.w5"
            :fill="onSG_select_color"
          ></circle>

          <!-- coloring doc type -->
          <text
            x=55
            y=110
            dominant-baseline="middle"
            text-anchor="start"
            :fill="onDT_sign_color"
            class="graph-filter"
          >유형별 도큐먼트</text>
          <circle
            cx=40
            cy=110
            r=7
            @click="onDTypeColoring()"
            :stroke="coloring('pink', 0.2, 1)"
            :stroke-width="line_width.w5"
            :fill="onDT_select_color"
          ></circle>
        </g>
        <g v-show="onDT"> 
          <!-- legend doc_type -->
          <text x=55 y=140 
            dominant-baseline="middle" text-anchor="start"
            :fill="coloring('bw', 0.01, 1)"
            class="graph-legend">책</text>
          <text x=55 y=160 
            dominant-baseline="middle" text-anchor="start"
            :fill="coloring('bw', 0.01, 1)"
            class="graph-legend">학위논문</text>
          <text x=55 y=180 
            dominant-baseline="middle" text-anchor="start"
            :fill="coloring('bw', 0.01, 1)"
            class="graph-legend">논문</text>
          <text x=55 y=200 
            dominant-baseline="middle" text-anchor="start"
            :fill="coloring('bw', 0.01, 1)"
            class="graph-legend">컨퍼런스</text>
          <text x=55 y=220 
            dominant-baseline="middle" text-anchor="start"
            :fill="coloring('bw', 0.01, 1)"
            class="graph-legend">뉴스</text>
          <text x=55 y=240 
            dominant-baseline="middle" text-anchor="start"
            :fill="coloring('bw', 0.01, 1)"
            class="graph-legend">잡지/블로그</text>
          <text x=55 y=260 
            dominant-baseline="middle" text-anchor="start"
            :fill="coloring('bw', 0.01, 1)"
            class="graph-legend">기타</text>
          <line
            x1="40" x2="40"
            y1="120" y2="260"
            :stroke="coloring('bw',0.03,1)"
            stroke-width="0.3"
          ></line>
          <circle cx=40 cy=140 r=4 :stroke="coloringDT(0,10,1)" stroke-width="0.3"
            :fill="coloringDT(0,1,1)"></circle>
          <circle cx=40 cy=160 r=4 :stroke="coloringDT(1,10,1)" stroke-width="0.3"
            :fill="coloringDT(1,1,1)"></circle>
          <circle cx=40 cy=180 r=4 :stroke="coloringDT(105,10,1)" stroke-width="0.3"
            :fill="coloringDT(105,1,1)"></circle>
          <circle cx=40 cy=200 r=4 :stroke="coloringDT(106,10,1)" stroke-width="0.3"
            :fill="coloringDT(106,1,1)"></circle>
          <circle cx=40 cy=220 r=4 :stroke="coloringDT(7,10,1)" stroke-width="0.3"
            :fill="coloringDT(7,1,1)"></circle>
          <circle cx=40 cy=240 r=4 :stroke="coloringDT(8,10,1)" stroke-width="0.3"
            :fill="coloringDT(8,1,1)"></circle>
          <circle cx=40 cy=260 r=4 :stroke="coloringDT(999,10,1)" stroke-width="0.3"
            :fill="coloringDT(999,1,1)"></circle>
        </g>       
      </g>
    </svg>
  </div>


</div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex"
import { sort_obj_array } from '../../../custom/fn_general.js'
import { drawing } from '../../../custom/tree_drawing'
import { coloring, coloringDT } from '../../../custom/fn_color.js'

export default {
  data(){
    return {

      busy: false, 

      base_node: {
        tree_mode: null, 
        node_info: null, 
      }, 

      screen: {
        width: window.window.width, 
        height: window.window.height
      }, 

      window : {
        width: window.innerWidth, 
        height: window.innerHeight
      }, 

      page: {
        width: null, 
        height: null, 
      }, 

      dict_docs: {}, 

      mouse_pageXY: {x: null, y: null}, 
      mouse_down: false, 
      mouse_scroll: false, 
      diff_xy: { x:null, y: null}, 
      k: null, 
      k_tracking: null, 
      xy_tracking: {x:0, y:0}, 

      touching: false,

      // canvas - not modified
      cvs_margin: {
        left: null, 
        right: null, 
        top: null, 
        bottom: null
      }, 
      cvs_grid: {
        width: null, height: null
      }, 
      // test cvs zero point
      test0point: {
        x: 0, y: 0
      }, 
      treeReady: false, 

      // canvas - variable - page xy
      cvs_size: { width: null, height: null, unit: null }, 
      cvs_position: { x_left: null, y_top: null }, 

      GraphV: {}, 
      vertex_table: [], 
      edge_table: [], 

      //transform function
      incR: null, 

      //vTable, eTable xy = cvs XY
      vTable: [], 
      eTable: [], 

      num_color: null, 

      //onVertexInformation
      onV: false, 
      onVertex: [], 

      // onVertex -> vertex, linked vertex upward, edge upward, edge downward
      LinkOnVertexUp : [], 
      LinkOnVertexDown: [], 
      OutOnVertex: [], 
      InOnVertex: [], 

      // click Vertex
      clickV: false, 
      clickVertex: {}, 
      LinkClickVertexUP: [], 
      LinkClickVertexDown: [], 
      OutClickVertex: [], 
      InClickVertex:[], 
      OutCV:[],
      InCV:[],
      checkEmptyClick: 0,

      // doc type coloring
      onDT_select_color: null,
      onDT: true,

      // project docs network
      onPD_sign_color: null, 
      onPD_select_color: null, 
      onPD: false, 
      vProjectDocs: [], 
      eProjectDocs: [], 

      // suggestion flow
      onDT_sign_color: null,
      onSG_sign_color: null, 
      onSG_select_color: null, 
      onSG: false, 
      vSuggestion: [], 
      eSuggestion: [], 

      line_width: {
        w0: 0, 
        w1: 0.1, 
        w2: 0.2, 
        w3: 0.3, 
        w4: 0.4, 
        w5: 0.5, 
        w9: 0.9, 
        w15: 1.5, 
        w20: 2.0, 
      }, 

      fill_color: {
        text: "hsla(223, 53%, 17%, 1)", //#142142
        click: "#FF6672", 
      }, 
    }
  }, 

  computed:{
    project_id(){
      return this.$route.params.id
    },

    route_name() {
      return this.$route.name
    },

    ...mapGetters({
      project_info: "project/project_info",
      tree_mode: "tree/tree_mode", 
      tree_base: "tree/tree_base", 
      
      documents: "tree/documents", 
      ranks: "tree/ranks", 
      references: "tree/references", 
      translations: "tree/translations", 
      collections: "tree/collections", 
      revisions: "tree/revisions", 

      on_sg: 'tree/on_sg',

      hovered_key: "project/hovered_key",

      changing_tree: "tree/changing_tree"
    }),

    num_proj_docs() {
      return this.project_info.num_docs
    },

    selected_doc_key() {
      return this.$route.query.doc
    }
  }, 

  watch:{
    num_proj_docs: {
      async handler(val) {
        await this.getTree()
      }
    },
    changing_tree: {
      async handler(val){
        if(val){
          await this.getTree()
        }
      }
    },

    hovered_key(val) {
      if(!this.changing_tree){
        let vid = this.GraphV.dict_N_to_V[val]
        this.onV = true
        this.onVertex = this.vTable.filter(v => v.vid == vid)[0]
      }
    },

    // mouse_pageXY : coord page xy
    mouse_pageXY: function(newValue, oldValue){
      this.diff_xy.x = 0
      this.diff_xy.y = 0

      if(event.pointerType=='mouse' || this.touching ){
        this.diff_xy.x = newValue.x-oldValue.x
        this.diff_xy.y = newValue.y-oldValue.y
      } 
      var move_effective = false
      var treemove_done = false
      
      move_effective = true
      if(move_effective){
        // on cvs & mouse down
        if(this.mouse_down) {
          // deplacement tree
          this.deplace_nv(this.diff_xy.x, this.diff_xy.y)
          treemove_done = true
          this.diff_xy.x = 0
          this.diff_xy.y = 0
        }
      }
      if(treemove_done){
        move_effective=false
        treemove_done=false
      }
    }, 
    onVertex: function(newValue){
      if(newValue && !!Object.keys(newValue).length){
        this.on_vertex(newValue)
        // console.log("[WATCH] onVertex ", newValue)
      } else {
        this.onV = false
      }
    },
    checkEmptyClick: function(newValue){
      if(newValue>1) {
        this.emptyClickVertex()
      }
    },
    on_sg(val) {
      if(this.GraphV.info.max_level>3){
        this.onSG = val
        if(val){
          this.onSG_select_color = this.coloring('lime', 1, 1)
        } else {
          this.onSG_select_color = this.coloring('bw', 1, 1)
        }
      }
    },
    async selected_doc_key(val){
      if(val!=null){
        let vid = this.GraphV.dict_N_to_V[val]
        // console.log('seelected_doc_key', val,vid)
        if(vid!=null) {
          this.onV = true
          this.onVertex = this.vTable.filter(v=>v.vid==vid)[0]
          // console.log("selected_key>onVertex ", this.onVertex)
          await this.setSelectedVertex()
        } else {
          
          this.onV = false
          this.off_vertex()
          this.emptyClickVertex()
          // console.log("out of tree ", this.onVertex)
        }
      }
    }
  }, 

  mounted(){
    window.onresize = ()=>{
      this.windowSetting()
    }
  }, 

  destroyed() {
    document.removeEventListener(`wheel`, this.detect_mouse_scroll);
  },

  async created(){
    await this.getTree()
    document.getElementById('tree').addEventListener(`wheel`, this.detect_mouse_scroll);
  }, 

  methods:{
    drawing, 
    sort_obj_array, 

    ...mapMutations({
      setVertexLibrary: 'tree/setVertexLibrary',
      setSgKeys: 'tree/setSgKeys',
      setOnSg: 'tree/setOnSg',
    }),
    
    //color: bw, 
    // black = coloring(bw, 0, 1) / white = coloring(bw, 1, 1)
    // navy, yellow, lotus, pink, scarlet, orange, turquoise, lime
    //coloring (color, light, opacity)
    coloring, 
    coloringDT,

    async getTree() {
      try {
        this.busy = true
        if(this.tree_mode == 'project') {
          await this.getProjectTreeData({
            project: this.project_id,
          })
          this.base_node.node_info = this.tree_base.title
          this.base_node.tree_mode = this.tree_mode
        } else if (this.tree_mode == 'watching-project') {
          await this.getWatchingProjectTreeData({
            project: this.project_id,
          })
          this.base_node.node_info = this.tree_base.title
          this.base_node.tree_mode = this.tree_mode
        } else if (this.tree_mode == 'documents') {
          await this.getDocsTreeData({
            documents : this.tree_base, 
            depth: 5, 
            use_recursive_cte: false, 
            with_all_relationship: true
          })
        }
      } finally {
        this.busy = false
        this.$store.commit('project/setHoveredKey', null)
        this.$store.commit('tree/setOnSg', false)
      }
        
      this.num_color = this.coloring('bw', 0.3, 1)
      // white
      this.onSG_select_color = this.coloring('bw', 1, 1)
      this.onPD_select_color = this.coloring('bw', 1, 1)
      this.onDT_select_color = this.coloring('pink', 1, 1)
    },
    
    async getProjectTreeData(project_tree){
      await this.$store.dispatch("tree/getProjectTreeData", project_tree)
      await this.makeDictDocs()
      await this.init_unit()
    }, 

    async getWatchingProjectTreeData(project_tree){
      await this.$store.dispatch("tree/getWatchingProjectTreeData", project_tree)
      await this.makeDictDocs()
      await this.init_unit()
    }, 
    
    async getDocsTreeData(docs_tree){
      await this.$store.dispatch("tree/getDocsTreeData", docs_tree)
      await this.makeDictDocs()
      await this.init_unit()
    }, 

    // doc-key -> doc object
    makeDictDocs(){
      this.documents.forEach(d=>{
        this.dict_docs[d.doc_key] = d
      })
      this.treeReady = false
      // console.log("dict_docs ", this.dict_docs)
    }, 

    async init_unit(){
      await this.windowSetting()
      await this.cvs_conditions()
      await this.init_cvs()
      await this.drawingGraph()
    }, 

    windowSetting(){
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight - 100
      this.screen.width = window.screen.width
      this.screen.height = window.screen.height - 100
      this.page.width = document.documentElement.scrollWidth
      this.page.height = document.documentElement.scrollHeight - 100
    }, 

    // canvas not modified
    cvs_conditions(){
      this.cvs_margin = { left: 0, right: 0, top: 0, bottom: 0 }
      // console.log("cvs_conditions : ", this.cvs_margin, ##) 
    }, 

    // canvas - variable : call for initialize
    init_cvs(){
      this.k = 1
      this.k_tracking = 1
      this.cvs_grid = { 
        width: this.page.width - this.cvs_margin.left - this.cvs_margin.right, 
        height: this.page.height - this.cvs_margin.top - this.cvs_margin.bottom, 
        unit: 1
      }
      if(this.cvs_grid.width > this.cvs_grid.height){
        this.cvs_grid.unit = this.cvs_grid.height/1000
      } else {
        this.cvs_grid.unit = this.cvs_grid.width/1000
      }

      this.cvs_size = { 
        width: this.page.width - this.cvs_margin.left - this.cvs_margin.right, 
        height: this.page.height - this.cvs_margin.top - this.cvs_margin.bottom, 
        unit: this.k_tracking
      }
      this.cvs_position.x_left = this.cvs_margin.left
      this.cvs_position.y_top = this.cvs_margin.top
      // console.log("init_cvs : ", this.cvs_position)
      
    }, 

    async drawingGraph(){
      // start drawing
      this.GraphV = await this.drawing(this.documents, this.ranks, this.references, this.translations, this.collections, this.revisions)
      this.setVertexLibrary(this.GraphV.vertex_library)
      await this.setRadius()
      // console.log("drawingGraph : ", this.GraphV)
      await this.plotGraph(this.GraphV)
      // DocType coloring
      // project docs network
      if(this.GraphV.info.n_ranks>2){
        await this.projDocsNw()
        if(this.vProjectDocs.length>0){
          this.onDT_sign_color = this.coloring('pink', 0.1, 1)
          this.onPD_sign_color = this.coloring('lotus', 0.1, 1)
        } else {
          this.onDT_sign_color = this.coloring('pink', 0.1, 0.5)
          this.onPD_sign_color = this.coloring('lotus', 0.1, 0.5)
        }
      } else {
        this.onDT_sign_color = this.coloring('pink', 0.1, 0.5)
        this.onPD_sign_color = this.coloring('lotus', 0.1, 0.5)
      }
      // suggestion flow
      if(this.GraphV.info.max_level>3){
        await this.suggestionFlow()
        if(this.vSuggestion.length>0){
          this.onSG_sign_color = this.coloring('lime', 0.1, 1)
        } else {
          this.onSG_sign_color = this.coloring('lime', 0.1, 0.5)
        }
      } else {
        this.setSgKeys([])
        this.onSG_sign_color = this.coloring('lime', 0.1, 0.5)
      }
      this.treeReady = true
      this.$store.commit('tree/changeTree', false)
    }, 

    async setRadius(){
      let mxVinL = this.GraphV.info.max_v_in_lv
      let nVsinG = this.GraphV.info.n_vertex

      // inclinaison
      let C_max = 4
      let C_min = 0.5
      
      // temp coef
      let alpha = 100
      let beta = 100

      let term1 = alpha * beta * (C_max - C_min)
      let term2 = mxVinL * (nVsinG + beta) * C_min
      let term3 = (mxVinL + alpha) * (nVsinG + beta)
      
      this.incR = (term1 + term2) / term3

      // console.log("[RADIUS] incR , ", mxVinL, nVsinG, this.incR)
    }, 

    projDocsNw(){
      let includeN = this.ranks[1]
      let includeV = []
      includeN.forEach(n=>{
        includeV.push(this.GraphV.dict_N_to_V[n])
      })
      includeV = [...new Set(includeV)]
      this.vProjectDocs = this.vTable.filter(v=>includeV.includes(v.vid))
      this.eProjectDocs = this.eTable.filter(e=>includeV.includes(e.es)&&includeV.includes(e.et))
      // console.log("[ProjectDocsNetwork] ", this.vProjectDocs, this.eProjectDocs)
    }, 

    suggestionFlow(){
      let suggestion_vid = []
      this.GraphV.vertex_levels.forEach(l=>{
        let max_d = 0
        let maxV = []
        for(let i=0; i<l.length;i++){
          let v = this.GraphV.vertex_library[l[i]]
          if(v.v_din.R>max_d) {
            max_d = v.v_din.R
          }
        }
        for(let j=0; j<l.length;j++){
          let vx = this.GraphV.vertex_library[l[j]]
          if(vx.v_din.R==max_d){
            maxV.push(vx.vid)
          }
        }
        if(max_d>3) {
          suggestion_vid.push(...maxV)
        }
      })
      this.vSuggestion = this.vTable.filter(v=>suggestion_vid.includes(v.vid))
      this.eSuggestion = this.eTable.filter(e=>suggestion_vid.includes(e.es)&&suggestion_vid.includes(e.et))
      let suggestion_vertex = this.vSuggestion.map(v=>v.nodes_obj)
      let suggestion_docs = []
      suggestion_vertex.forEach(v=> { suggestion_docs = suggestion_docs.concat(v) })
      let suggestion_keys = suggestion_docs.map(v => v.doc_key)
      this.setSgKeys(suggestion_keys)
      // console.log("[Suggestion] ", this.vSuggestion, this.eSuggestion)
    }, 

    onProjectDocs(){
      if(this.GraphV.info.n_ranks>2){
        this.onPD = !this.onPD
        if(this.onPD) {
          this.onPD_select_color = this.coloring('navy', 1, 1)
        } else {
          this.onPD_select_color = this.coloring('bw', 1, 1)
        }
      }
    }, 

    onSuggestion(){
      if(this.GraphV.info.max_level>3){
        this.onSG = !this.onSG
        if(this.onSG){
          this.onSG_select_color = this.coloring('lime', 1, 1)
        } else {
          this.onSG_select_color = this.coloring('bw', 1, 1)
        }
      }
      this.setOnSg(this.onSG)
    }, 

    onDTypeColoring(){
      this.onDT = !this.onDT
      if(this.onDT) {
        this.onDT_select_color = this.coloring('pink', 1, 1)
      } else {
        this.onDT_select_color = this.coloring('bw', 1, 1)
      }
    },

    async plotGraph(G){
      this.diff_xy.x = 0
      this.diff_xy.y = 0
      this.k_tracking = 1
      this.xy_tracking = {x:0, y:0}

      this.vertex_table = G.vertex_table
      this.edge_table = G.edge_table

      // vertex xy -> cvs position xy
      this.vTable = this.vertex_table.map(v=>{
        let nodes = []
        let a_node = {}
        
        // add information(author, title) into  node
        for(let i=0; i<v.nodes.length; i++){  
          a_node = v.nodes[i]
          let a_node_obj = this.dict_docs[a_node]

          if(a_node !="project"){            
            a_node_obj["info_au"] = ""
            for(let j=0; j<a_node_obj.authors.length ; j++) {
              if(j==0){ a_node_obj.info_au = a_node_obj.authors[j].lastname.toUpperCase()}
              else {
                a_node_obj.info_au = a_node_obj.info_au + " ; " + a_node_obj.authors[j].lastname.toUpperCase()
              }
            }
            if(a_node_obj.info_au.length>20){
              var a_info = a_node_obj.info_au.substring(0, 20)
              a_node_obj.info_au = a_info + "..."
            }
            a_node_obj["info_title"] = ""
            if(a_node_obj.title.length>20){
              var t_info = a_node_obj.title.substring(0, 30)
              a_node_obj.info_title = t_info + "..."
            }            
          }   
          nodes.push(a_node_obj)         
        }
        
        return {
          vid: v.vid, 
          in_d: v.in_d, 
          n_nodes: v.nodes.length, 
          nodes_obj: nodes, 
          x: v.x, 
          y: v.y, 
          w: this.cvsR(v.in_d)
        }
      })

      // sort property array
      let sortPropArray = [{prop: "in_d", dir: -1}]
      this.vTable = this.sort_obj_array(this.vTable, sortPropArray)

      this.eTable = this.edge_table.map(e=>{
        let start = G.vertex_library[e.source_id]
        let end = G.vertex_library[e.target_id]
        let startx = start.position.x
        let starty = start.position.y
        let endx = end.position.x
        let endy = end.position.y
        return {
          ei: e.source_id.toString()+"-"+e.target_id.toString(), 
          es: start.vid, 
          et: end.vid, 
          sx: startx, 
          sy: starty, 
          tx: endx, 
          ty: endy, 
          kind: e.kind
        }
      })
    }, 
    
    cvsR(in_d){
      return this.incR * in_d + 2
    }, 

    // cvs xy -> page xy
    cv2pgX(x){
      let Cx = this.cvs_grid.unit * this.cvs_size.unit
      let moveX = (this.cvs_size.width - 1000 * Cx) * 0.5
      return x * Cx + this.cvs_position.x_left + moveX
    }, 

    cv2pgY(y){
      let Cy = this.cvs_grid.unit * this.cvs_size.unit
      let moveY = (this.cvs_size.height - 1000 * Cy) * 0.5
      return y * Cy + this.cvs_position.y_top + moveY
    }, 

    detect_mouse_down(){
      this.mouse_down = true
      this.mouse_scroll = false
      this.touching = true
    }, 

    detect_mouse_up(){
      this.touching = false
      this.mouse_down = false
      this.mouse_move = false
      this.mouse_scroll = false
      this.mouse_down_start = null
      this.mouse_down_elapsed = 0
    }, 

    detect_mouse_move(){
      if(event.pointerType=='touch' || event.pointerType=='pen'){
        this.mouse_pageXY = {
          x: event.touches[0].clientX,
          y: event.touches[0].clientY
        }
      } else {
        this.mouse_pageXY = {
          x: event.pageX, y: event.pageY
        }
      }        
      // console.log("pageXY", event.pageX, event.pageY)
      // console.log("screenXY", event.screenX, event.screenY)
      // console.log("clientXY", event.clientX, event.clientY)
      // console.log("pointertype", event.pointerType)
      this.mouse_move = true
      this.mouse_scroll = false
    }, 

    detect_mouse_scroll(){
      this.mouse_scroll = true
      
      var cx = this.mouse_pageXY.x
      var cy = this.mouse_pageXY.y

      var limit_deltaY = 100
      var outside_limit = false
      if (event.deltaY>limit_deltaY || event.deltaY<(-1*limit_deltaY)){
        outside_limit = true
      }
      if(outside_limit == false){
        var scroll = 0.5*event.deltaY
        var zoom_sensitive = 0.009
        let deltaK = 1-scroll*zoom_sensitive
        if(this.k_tracking>0.8 || scroll<0){
          // console.log("k_tracking", this.k_tracking)
          this.zoom_nv(cx, cy, deltaK)
        } 
        this.mouse_scroll = false
      }      
    }, 

    deplace_nv(dx, dy){
      this.cvs_position.x_left = this.cvs_position.x_left + dx
      this.cvs_position.y_top = this.cvs_position.y_top + dy
      this.xy_tracking.x = this.xy_tracking.x + dx/this.k_tracking
      this.xy_tracking.y = this.xy_tracking.y + dy/this.k_tracking
    }, 
    
    zoom_nv(cx, cy, k){
      let delta_x = 0
      let delta_y = -60.5

      cx = cx + delta_x
      cy = cy + delta_y

      

      this.k_tracking = this.k_tracking * k
      this.cvs_size.unit = this.cvs_size.unit * k
      this.cvs_position.x_left = k * (this.cvs_position.x_left) + cx * (1-k)
      this.cvs_position.y_top = k * (this.cvs_position.y_top) + cy * (1-k)
      this.cvs_size.height = this.cvs_grid.height * this.k_tracking
      this.cvs_size.width = this.cvs_grid.width * this.k_tracking
    }, 

    on_vertex(vertex){
      this.onVertex = vertex
      // console.log("[CHECK] ON vertex", vertex)
      this.LinkOnVertexUp = []
      this.LinkOnVertexDown = []
      this.OutOnVertex = []
      this.InOnVertex = []

      this.eTable.forEach(e=>{
        if(e.es==vertex.vid) {
          this.LinkOnVertexUp.push(e)
        } else if (e.et==vertex.vid){
          this.LinkOnVertexDown.push(e)
        }
      })

      let outsV = this.GraphV.vertex_library[vertex.vid].v_outs.total
      let insV = this.GraphV.vertex_library[vertex.vid].v_ins.total

      // console.log("[CHECK] ON vertex edge finished", outsV, insV)

      this.vTable.forEach(v=>{
        if(outsV.includes(v.vid)){
          this.OutOnVertex.push(v)
        } else if(insV.includes(v.vid)){
          this.InOnVertex.push(v)
        }
      })

      // console.log("[CHECK] ON vertex vertex finished", this.OutOnVertex)


      // console.log(this.LinkOnVertexUp, this.LinkOnVertexDown, this.OutOnVertex, this.InOnVertex)
    }, 

    off_vertex(){
      this.onVertex = {}
      this.LinkOnVertexUp = []
      this.LinkOnVertexDown = []
      this.OutOnVertex = []
      this.InOnVertex = []
    }, 
    
    clickVertexM(v){
      if(this.clickV && this.clickVertex.vid==v.vid){
        this.emptyClickVertex()
        
      } else {
        // list of multiple docs
        // console.log("CLICK VERTEX Multiple nodes : ", v.nodes_obj)
        this.ClickingVertex()
      }
    }, 
    clickVertexS(v){
      if(this.clickV && this.clickVertex.vid==v.vid){

        this.emptyClickVertex()
      } else {
        // single doc
        // console.log("CLICK VERTEX Single node : ", v.nodes_obj[0])
        this.ClickingVertex()
      }
    }, 
    emptyClickVertex(){
      this.checkEmptyClick = 0
      this.clickV = false
      this.clickVertex = {}
      this.LinkClickVertexUP = []
      this.LinkClickVertexDown = []
      this.OutClickVertex = []
      this.InClickVertex = []
      this.OutCV = []
      this.InCV = []
    }, 

    async ClickingVertex(){
      await this.setClickVertex()
      await this.sendClicked()
    },

    setSelectedVertex(){
      this.setClickVertex()
    },

    setClickVertex(){
      this.checkEmptyClick = 0
      this.clickV = true
      this.clickVertex = JSON.parse(JSON.stringify(this.onVertex))
      this.LinkClickVertexUp = JSON.parse(JSON.stringify(this.LinkOnVertexUp))
      this.LinkClickVertexDown = JSON.parse(JSON.stringify(this.LinkOnVertexDown))
      this.OutClickVertex = JSON.parse(JSON.stringify(this.OutOnVertex))
      this.InClickVertex = JSON.parse(JSON.stringify(this.InOnVertex))
      this.OutCV = this.OutClickVertex.map(v=>v.vid)
      this.InCV = this.InClickVertex.map(v=>v.vid)
      // console.log('clickVertex', this.clickVertex)
    },
    sendClicked(){
      if (this.route_name == 'project' || this.route_name == 'watching-project') {
        if(this.clickVertex.vid==0){
          // WORK TO DO: 
          // 프로젝트 버텍스 클릭 후 오른쪽 패널 프로젝트 도큐먼트 리스트 강제 활성화
          // 혹은 도큐먼트 상세 페이지였다면 프로젝트 도큐먼트 리스트로 변경
          // console.log("project click ")
        } else {
          let to = this.clickVertex.nodes_obj.length != 1 ?
          { query: { vid: this.clickVertex.vid } } :
          { query: { doc: this.clickVertex.nodes_obj[0].doc_key } }
          this.$router.replace(to)
        }
      }
    } ,
   

    checkClick(){
      this.checkEmptyClick +=1
    },
    
    // coloring
    // edge (type: B/base, select>U/hover_up, D/hover_down, 
    //    P/proj_docs, S/sugg, N/normal)
    // edge (kind: R/ref, T/trans, C/coll, V/rev)
    edgeColor(type, edge) {
      let color = null
      let eOP = 1
      if(this.onPD||this.onSG) { eOP = 0.3 }

      if(type=='B') { color = this.coloring('bw', 0.02, eOP) } //grey
      else if(type=='U') { color = this.coloring('orange', 1, 0.7)} 
      else if(type=='D') { color = this.coloring('turquoise', 1, 0.7) } //#66e5d1
      else if(type=='P') { color = this.coloring('lotus', 1, 1) } 
      else if(type=='S') { color = this.coloring('lime', 1, 1) } 
      else if(type=='N') { color = this.coloring('scarlet', 1, 1) } //#ff9628
      // for click
      else if(type=='CU') { color = this.coloring('orange', 1, 0.1)}
      else if(type=='CD') { color = this.coloring('turquoise', 1, 0.1)}
      
      return color
    }, 
    edgeDash(type, edge) {
      let kind = edge.kind
      let dash = ""
      if(kind=='R') { dash = '0'}
      else if(kind=='T') { dash = '3, 3' }
      else if(kind=='C') { dash = '3, 1' }
      else if(kind=='V') { dash = '0.9' }
      return dash
    }, 
    edgeWidth(type, edge) {
      let width = ""
      if(type=='B') { width = 0.15}
      else if(type=='U') { width = 0.5 }
      else if(type=='D') { width = 0.9 }
      else if(type=='P') { width = 0.2 }
      else if(type=='S') { width = 0.9 }
      else if(type=='N') { width = 0.9 }
      else if(type=='CU') { width = 2 }
      else if(type=='CD') { width = 2 }
      return width
    }, 
    // vertex color
    // color mode : G/grey, D/doctype, T/usertag
    vertexColor(type, multiple, halo, vertex){
      let color = null
      // Check Multiple Nodes > change light , default LT = 1
      let LT = 1
      if (multiple>1) { LT = 10 }

      let vOP = 0.90
      // Check Halo > change opacity
      if (halo == 1) { vOP = 0.5 }
      /// Check Making Background > change opacity
      if(this.onPD || this.onSG) { vOP = 0.3 }

      if(type=='B') { 
        // check vertex with a node & doctype coloring mode
        if(this.onDT && multiple==1 && vertex.vid!=0){
          let a_node = vertex.nodes_obj[0]
          let dtype = a_node.doc_type
          color = this.coloringDT(dtype, 1, vOP)
        } else {
          color = this.coloring('bw', 0.01*LT, vOP) 
        }
      } 
      
      else if(type=='H') { color = this.coloring('pink', 1, vOP) }
      else if(type=='U') { color = this.coloring('orange', 1, 0.3) } 
      else if(type=='D') { color = this.coloring('turquoise', 1, 0.3)} 
      else if(type=='P') { color = this.coloring('lotus', 1, 1)} 
      else if(type=='S') { color = this.coloring('lime', 1, 1) } 
      else if(type=='N') { color = this.coloring('scarlet', 1, 1) }

      else if(type=='CB') { color = this.coloring('pink', 1, vOP) }
      else if(type=='CH') { color = this.coloring('pink', 1, vOP) }
      else if(type=='CU') { color = this.coloring('orange', 1, vOP) } 
      else if(type=='CD') { color = this.coloring('turquoise', 1, vOP)}
      
      return color
    }, 
    vertexSize(type, multiple, halo, vertex) {
      let size = vertex.w
      if (multiple>1) { size = size * 1.3 }
      if (halo==1) { size = size * 2}
      if (this.onDT) { size = size * 1.1}
      
      if(type=='CH'||type=='CU'||type=='CD') { size = size *0.5 }
      return size
    }, 
    vertexOutline(type, vertex){
      let width = 0
      if(type=='B') { 
        // check vertex with a node & doctype coloring mode
        if(this.onDT){ width = 0 
        } else { width = 0.1 }
      } 
      else if(type=='CB') { width = 1}
      else if(type=='H') { width = 0 }
      else if(type=='U') { width = 0 } 
      else if(type=='D') { width = 0} 
      else if(type=='P') { width = 1.2 } 
      else if(type=='S') { width = 1 } 
      else if(type=='N') { width = 0 }
      return width
    }, 
    vertexOutlineColor(type, multiple, halo, vertex){
      let color = null

      // Check Multiple Nodes > change light
      let LT = 1
      if (multiple>1) { LT = 0.2 }
      
      // Check Halo > change opacity
      let vOP = 1
      if (halo == 1) { vOP = 0.2 }

      // Check Making Background > change opacity
      if(this.onPD || this.onSG) { vOP = 0.1 }

      if(type=='B') { 
        // check vertex with a node & doctype coloring mode
        if(this.onDT && multiple==1 && vertex.vid!=0){
          let a_node = vertex.nodes_obj[0]
          let dtype = a_node.doc_type
          color = this.coloringDT(dtype, 100, vOP)
        } else {
          color = this.coloring('bw', 0.01 * LT, vOP) 
        }
      } 
      else if(type=='CB') { color = this.coloring('pink', 1, vOP) }
      else if(type=='H') { color = this.coloring('pink', 1, vOP) }
      else if(type=='U') { color = this.coloring('orange', 1, 0.3) } 
      else if(type=='D') { color = this.coloring('turquoise', 1, 0.3)} 
      else if(type=='P') { color = this.coloring('lotus', 1, 1)} 
      else if(type=='S') { color = this.coloring('lime', 0.2, 1) } 
      else if(type=='N') { color = this.coloring('scarlet', 1, 1) }
      
      return color
    }, 
    textColor(type, color, opacity){
      let color_x = null
      // type: N/number, P/person, D/date, T/title
      // select Mode
      if(this.onPD || this.onSG) { opacity = 0.1 * opacity}

      if(type=='N'){ color_x = this.coloring('bw', 0.01, 1*opacity)} 

      return color_x
    }
  }
}
</script>
<style scoped>
#tree-layout {
  width: 100%;
  height: 100vh;
}

#tree-loading {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
}

#tree-info {
  position: absolute;
  margin: 0 0 0 100;
  z-index: 1;
  top: 0;
}

.tree-cvs{
  background-color: aliceblue;
}
circle {
  cursor: pointer;
}
.base_vertex{
  font-size: 10pt;
  font-weight: 500;
  fill: hsla(223, 53%, 17%, 0.8);
}
.num-in-v{
  font-size: 7pt;
  font-weight: 500;
}
.num-in-v-white{
  font-size: 7pt;
  font-weight: 500;
  fill:white;
}
.hover-info-au{
  font-size:8pt;
  font-weight: 400;
  fill: hsla(223, 53%, 17%, 1); 
  /* #142142 */
}
.hover-info-title{
  font-size:7pt;
  font-weight: 300;
  fill: hsla(223, 53%, 17%, 0.5);;
}
.hover-v-text{

}
.graph-filter{
  font-size:9pt;
  font-weight: 600;
}
.graph-legend{
  font-size:8pt;
  font-weight: 400;
}
.graph-filter-text-au{
  font-size:8pt;
  font-weight:400;
  fill: hsla(223, 53%, 17%, 0.7)
}
.graph-filter-text-title{
  font-size:7pt;
  font-weight:300;
  fill:hsla(223, 53%, 17%, 0.3);
}
</style>


// WEBPACK FOOTER //
// src/components/shared_components/tree/Tree.vue